import React from 'react';
import CreateUpdateAnnounce from '../CreateUpdateAnnounce/CreateUpdateAnnounce';

const NewAnnounce = ({ history }) => {
  return <CreateUpdateAnnounce history={history} />;
};

export default NewAnnounce;